import { cn } from "@/lib/utils";

export function LocationIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-[21px] w-4 text-rose-red", className)}
      viewBox="0 0 16 21"
      {...props}
    >
      <path
        d="M8 20.693s7.5-7.107 7.5-12.5a7.5 7.5 0 00-15 0c0 5.393 7.5 12.5 7.5 12.5zm0-8.75a3.75 3.75 0 110-7.5 3.75 3.75 0 010 7.5z"
        fill="currentColor"
      />
    </svg>
  );
}
